import { call, put, takeLatest } from "redux-saga/effects";
import { appConfigApi } from "../../../api/common/appConfigApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { actions } from "../../actions";
import { eAppConfigActionTypeIds } from './../../action-types/common/IAppConfigActionType';

export function* appConfigSaga(): any {
    yield takeLatest(eAppConfigActionTypeIds.LOAD_START, loadWorker)
}
function* loadWorker(): any {
    const res: IBaseRespone = yield call(appConfigApi.getAll)
    if (res.is_success) {
        yield put(actions.appConfig.loadSuccess(res.data))
    } else {
        yield put(actions.appConfig.loadError(res.message))
    }
}